import React, { useEffect, useState } from 'react';
import Page from '~/src/components/PageLayout';
import { useMatterDetail } from '../../hooks/useMatterDetail';
import { MatterDetailsPageContent } from './MatterDetailsPageContent';

export const MatterDetailsPage = ({ matterId, matterTitle }) => {
  const [title, setTitle] = useState(matterTitle || 'Loading Matter...');
  const {
    isError,
    isFetching,
    data: matter,
    refetch,
    remove,
  } = useMatterDetail(matterId, {
    refetchOnWindowFocus: false,
    staleTime: Number.POSITIVE_INFINITY,
    onSuccess: (matter) => setTitle(matter.fullTitle()),
    onError: () => setTitle('Error'),
  });

  useEffect(() => remove, [remove]);

  return (
    <Page title={title}>
      <MatterDetailsPageContent
        refetch={refetch}
        isFetching={isFetching}
        isError={isError}
        matter={matter}
      />
    </Page>
  );
};
